module.exports = __webpack_public_path__ + "static/media/suitcase.6bb7704b.svg";